var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-progress-linear',{attrs:{"color":"primary","indeterminate":""}}):_vm._e(),_c('v-row',{staticClass:"mx-5"},[_c('v-col',{attrs:{"cols":"12"}},[_c('q-lead-counts',{attrs:{"counts":_vm.lead_counts,"loading":_vm.loading}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }